/**
 * Plain-text / CSV preview extractor. Reads the first ~4 KB and trims to the
 * first 100 lines. CSV-shaped content lands here when the file is a literal
 * `.csv` — Excel-shaped `.xlsx` use the excel extractor instead.
 */

const MAX_CHARS = 4000;
const MAX_LINES = 100;

export async function extractPlainPreview(file: File): Promise<string> {
  try {
    // Read only the first chunk to avoid loading multi-MB log files.
    const slice = file.slice(0, 64 * 1024);
    const text = await slice.text();
    return text
      .split(/\r?\n/)
      .slice(0, MAX_LINES)
      .join("\n")
      .slice(0, MAX_CHARS);
  } catch (err) {
    console.warn(`[irl-match] Plain extraction failed for "${file.name}":`, err);
    return "";
  }
}
